import { styled } from '@mui/material/styles';

import PageTopMarginWrapper from '@/components/ui/PageTopMarginWrapper/PageTopMarginWrapper';

export const Wrapper = styled(PageTopMarginWrapper)(({ theme }) => ({
  paddingTop: theme.spacing(2.5),
  paddingBottom: theme.spacing(2.5),
  display: 'flex',
  justifyContent: ' space-between',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const Heading = styled('div')(({ theme }) => ({
  '& > *': {
    ...theme.typography.h1,
    margin: 0,
    fontWeight: theme.typography.fontWeightRegular,
    strong: {
      fontWeight: theme.typography.fontWeightBlack,
    },
  },
  paddingBottom: theme.spacing(2),
  maxWidth: 320,

  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 0,
    width: 'auto',
    maxWidth: 420,
  },

  [theme.breakpoints.down('md')]: {
    '& > *': {
      ...theme.typography.h2,
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
}));

export const ImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  maxWidth: 320,
  marginTop: theme.spacing(10.5),

  img: {
    maxWidth: 320,
    objectFit: 'contain',
    height: '100%',
  },

  [theme.breakpoints.down('lg')]: {
    justifyContent: 'center',
    height: 160,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },

  [theme.breakpoints.down('md')]: {
    height: 115,
  },
}));

export const FormWrapper = styled('div')(({ theme }) => ({
  width: 746,
  marginLeft: theme.spacing(1),
  display: 'flex',
  justifyContent: 'center',

  [theme.breakpoints.down('lg')]: {
    width: '100%',
    minHeight: 'auto',
    marginLeft: 0,
  },
}));
